import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { PermissionModels, UtilsModels } from '@share-models';
import { AppState } from '../store/app.state';
import { checkAccessPermissionsAND } from '../store/state/permissions/permissions.selectors';
import { routerSegments } from '../consts/routes';
import NotFoundTemplates = UtilsModels.NotFoundTemplates;

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const store$ = inject(Store<AppState>);
  const router: Router = inject(Router);

  const requiredPermissions: PermissionModels.Permissions[] =
    (route.data['permissions'] as PermissionModels.Permissions[]) ?? [];

  return store$.select(checkAccessPermissionsAND(requiredPermissions)).pipe(
    map((isAllowed) => {
      if (!isAllowed) {
        void router.navigate([routerSegments.notPermitted], {
          queryParams: { template: NotFoundTemplates.NotPermitted },
        });
      }
      return isAllowed;
    }),
  );
};
